var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFilesIllustration = function SvgIcFilesIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007CFF",
    d: "m50.398 32.378-6.611 3.532a1.224 1.224 0 0 1-1.664-.505 1.224 1.224 0 0 1 .505-1.664l6.611-3.532a1.224 1.224 0 0 1 1.664.505 1.227 1.227 0 0 1-.505 1.664Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m50.398 32.378-6.611 3.532a1.224 1.224 0 0 1-1.664-.505 1.224 1.224 0 0 1 .505-1.664l6.611-3.532a1.224 1.224 0 0 1 1.664.505 1.227 1.227 0 0 1-.505 1.664Z",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2276A6",
    d: "m86.448 41.546-.053 60.205c0 .775-.632 1.402-1.407 1.402l-55.671-.051a1.406 1.406 0 0 1-1.403-1.407l.07-78.309c0-.775.632-1.402 1.407-1.402l37.51.034 19.547 19.528Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007CFF",
    d: "m77.933 59.67-41.507.086.005 2.574 41.508-.087-.005-2.574ZM77.953 70.18l-41.508.088.006 2.573 41.507-.086-.005-2.574ZM77.976 80.698l-41.507.087.005 2.574 41.508-.087-.006-2.574ZM66.94 21.978l-.017 18.16c0 .776.627 1.403 1.402 1.407l18.104.017-19.49-19.584Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m66.94 21.978-.017 18.16c0 .776.627 1.403 1.402 1.407l18.104.017-19.49-19.584Z",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#74C1EC",
    d: "m92.34 36.61-.431 60.203a1.405 1.405 0 0 1-1.416 1.393l-55.67-.4a1.405 1.405 0 0 1-1.393-1.416l.562-78.307a1.405 1.405 0 0 1 1.415-1.393l37.51.27L92.34 36.61Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m92.194 36.407-.053 60.205c0 .775-.632 1.402-1.407 1.402l-55.671-.05a1.405 1.405 0 0 1-1.403-1.407l.07-78.31c0-.775.632-1.401 1.407-1.402l37.51.035 19.547 19.527Z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#59A7D2",
    d: "m82.57 54.533-39.291.081c-.61 0-1.108.5-1.104 1.109l.002.357c0 .61.5 1.107 1.109 1.104l39.29-.082c.61.001 1.108-.499 1.105-1.108l-.003-.357a1.11 1.11 0 0 0-1.108-1.104ZM82.589 65.047l-39.291.08c-.61 0-1.107.5-1.104 1.11l.003.357c0 .61.499 1.107 1.108 1.103l39.292-.08c.61 0 1.107-.5 1.103-1.11l-.002-.357c0-.61-.495-1.103-1.109-1.103ZM82.612 75.564l-39.29.081c-.61 0-1.108.5-1.104 1.11l.002.356c0 .61.5 1.108 1.109 1.104l39.29-.081c.61 0 1.108-.5 1.105-1.11l-.003-.356a1.1 1.1 0 0 0-1.109-1.104Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#74C1EC",
    d: "m72.947 16.92-.13 18.16a1.408 1.408 0 0 0 1.393 1.416l18.104.13L72.947 16.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m72.677 16.841-.016 18.16c0 .776.627 1.404 1.402 1.407l18.105.017-19.49-19.584Z",
    opacity: 0.7
  })));
};
export default SvgIcFilesIllustration;